import { moduleName } from '../constants';

export const ROUTE_SCOUTBOOK_LEGACY = `${moduleName}/ROUTE_SCOUTBOOK_LEGACY`;
export const navigateToScoutbookLegacy = () => ({
  type: ROUTE_SCOUTBOOK_LEGACY,
});
